import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Header from '../../Layout/Header';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import Section5 from './Section5';
import Section6 from './Section6';
import Section7 from './Section7';
import Section8 from './Section8';
import Section9 from './Section9';
import axios from 'axios';
import { SERVER_URL } from '../../../config';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from "react-router-dom";
import Footer from '../../Layout/Footer';
import { jwtDecode } from 'jwt-decode';

AOS.init();

export default function Home() {

  const [showSlides, setShowSlides] = useState(false);
  const [OpenClubModal, setOpenClubModal] = useState(false);
  const navigate = useNavigate();
  let token = sessionStorage.getItem('player_token')

  useEffect(() => {
    if (token) {
      checkProfile();
      check_DNA_register()
    }
  }, [token]);

  const checkProfile = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/v2/player-profile-check`, {
        headers: { Authorization: `Bearer ${token}`, }
      });
      if (response.data.status === true && response.data.msg === 'updated') {
        setIsSection1Visible(true);
        setShowSlides(false);
      } else if (response.data.status === true && response.data.msg === 'not updated') {
        setIsSection1Visible(true);
        setShowSlides(true);
      } else {
        setIsSection1Visible(false);
        setShowSlides(false);
      }
    } catch (error) {
      console.error("Error checking the player profile : ", error);
      if (error.response?.status === 403) {
        toast.error(`${error?.response?.data?.error?.msg}`);
        setTimeout(() => {
          toast.dismiss()
          navigate('/player/Login');
        }, 1500);
      }
      setIsSection1Visible(false);
      setShowSlides(false);
    }
  }

  const check_DNA_register = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/v2/player-profile-dna`, {
        headers: { Authorization: `Bearer ${token}`, }
      });
      console.log(response);
      
      if (response.data.status === true && response.data.msg === 'registered') {
        setDnaPopUp(true);
      } else if (response.data.status === true && response.data.msg === 'not registered') {
        setDnaPopUp(false);
      } else {
        setDnaPopUp(false);
      }
    } catch (error) {
      console.error("Error checking the player dna registration : ", error);
      if (error.response?.status === 403) {
        toast.error(`${error?.response?.data?.error?.msg}`);
        setTimeout(() => {
          toast.dismiss()
          navigate('/player/Login');
        }, 1500);
      }
      setDnaPopUp(false);
    }
  }

  const [activeIndex, setActiveIndex] = useState(0);
  const [isSection1Visible, setIsSection1Visible] = useState();
  const [scroll, setScroll] = useState(0);
  const [DnaPopUp, setDnaPopUp] = useState();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get('source');
const checkTokenValidity = (token) => {

        if (!token) return null;
        try {
            const decoded = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);
            if (decoded.exp < currentTime) {
                sessionStorage.removeItem("player_token");
                sessionStorage.removeItem("club_token");
                return null;
            }
            return decoded.email;
        } catch (error) {
            return null;
        }
    };
  useEffect(() => {
    console.log(source)
    const clubToken=sessionStorage.getItem("club_token")
    if(source==="club" && checkTokenValidity(clubToken)){
      setIsSection1Visible(true);
                      setTimeout(() => {
                        document.getElementById('section1').scrollIntoView({ behavior: 'smooth' });
                      }, 100); return setOpenClubModal(true)}
    const timer = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % 5);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scale = 1 + scroll / 500;
  const maxScale = 2;

  const videoStyle = {
    position: 'fixed',
    zIndex: '-1',
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%) scale(${Math.min(scale, maxScale)})`,
    width: '100%',
    height: '100%',
  };

  return (
    <div className='text-white '>
      <div className='video-content'>
        <video
          className='absolute inset-0 object-cover object-center w-full h-full scale-110'
          autoPlay
          muted
          loop
          playsInline
          style={videoStyle}
        >
          <source src='https://fish-nft.s3.ap-south-1.amazonaws.com/bg.mp4' type='video/mp4' />
        </video>
        <div className='absolute inset-0 bg-[#0E081B]/30'></div>
      </div>
      <div className='content'>
        <div className='flex flex-col h-screen'>
          <Header />
          <div className='Goaldex flex flex-1 items-center justify-center relative'>
            <div className='w-[90%]'>
              <h1 className='GOAL-cap font-bold flex justify-center text-center text-5xl md:text-[90px] lg:text-[175px] 2xl:text-[200px] tracking-[10px] md:tracking-[30px]'>
                <span className='GOAL-ball flex items-center'>G<span>
                  <img src='/assets/others/Ball.svg' className='w-[40px] md:w-[75px] ball-O lg:w-auto -translate-x-1 md:-translate-x-2 border-2 md:border-4 border-white rounded-full ball-spin p-1 lg:p-2'></img>
                </span>AL</span>DEX
              </h1>
              <div className='w-[100%] lg:w-[80%] 2xl:w-[75%] mx-auto fade-up-slide'>
                <div className='w-7 h-7 bg-[#5C1FE2] translate-y-[2px] ml-40' style={{ clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)' }}></div>
                <div className='flex flex-col lg:flex-row gap-5 lg:gap-10 items-center justify-around px-5 py-5 rounded-xl border-2 border-[#5C1FE2] bg-white/5 backdrop-blur-[3px]'>
                  <h1 className='font-semibold text-center lg:text-left'>Integrating genetic insights, performance analytics, and precision coaching to develop elite athletes.</h1>
                  <button
                    className='flex bg-white rounded-full px-4 items-center py-2 text-[#5C1FE2] text-xs 2xl:text-base font-bold duration-300 hover:bg-[#5C1FE2] hover:text-white cursor-pointer'
                    onClick={() => {
                      setIsSection1Visible(true);
                      setTimeout(() => {
                        document.getElementById('section1').scrollIntoView({ behavior: 'smooth' });
                      }, 100);
                    }}
                  >
                    GET STARTED <FontAwesomeIcon icon={faArrowRight} className='ml-2' />
                  </button>
                </div>
              </div>
              {/*
              <div className='absolute bottom-[7%] left-[5%]'>
                <h1>Follow</h1>
                <div className='flex gap-3 items-center mt-2'>
                  <i className='fab fa-facebook text-xl cursor-pointer brand-fade' ></i>
                  <i className='fab fa-x-twitter text-xl cursor-pointer brand-fade-2' ></i>
                  <i className='fab fa-instagram text-xl cursor-pointer brand-fade-3' ></i>
                  <i className='fab fa-discord text-xl cursor-pointer brand-fade-4' ></i>
                </div>
              </div>*/}
            </div>
          </div>
        </div>
        {isSection1Visible && (
          <div>
            <div id='section1'>
              <Section1 showSlides={showSlides} OpenClubModal={OpenClubModal} />
            </div>
            <div id='section2'>
              <Section2 />
            </div>
            {/*
            <div id='section3'>
              <Section3 />
            </div>*/}
            <div id='section4'>
              <Section4 />
            </div>
            {/*<div id='section5'>
              <Section5 />
            </div>*/}
            <div id='section6'>
              <Section6 />
            </div>
            <div id='section7'>
              <Section7 />
            </div>
            <div id='section8'>
              <Section8 />
            </div>
            {/*<div id='section9'>
              <Section9 />
            </div>*/}
            <div>
              <Footer />
            </div>
          </div>


        )}

      </div>

    </div>
  );
}